/* eslint-disable no-console */
import React from 'react';

const About = () => (
  <div>
    <div className="menu-nav-item">About the Project</div>
    <p>
      The Milwaukee District North tracks sit just beyond the alley in my backyard.
      During off-peak hours, freight trains are cleared to run along this stretch of the Metra corridor.
      They rumble past my home office window at seemingly random intervals while I work and attempt to apply structure to this new phase of my career.
    </p>
    <p>
      This project also brought me up to speed with React/Redux and was developed using the MERN stack.
    </p>
  </div>
);

export default About;
/* eslint-enable no-console */
